import { removeArrayElement } from "../../../utils/general";
import { ADD_INVOICE, CREATE_PROPERTY_INVOICES, DELETE_INVOICES, FETCH_INVOICES, LOG_OUT_USER } from "../../actions/actionTypes";

const fetchInvoicesReducer = (invoices, payload) => {
    let newInvoices = payload.appendData || payload.offset == "" ? [ ...invoices ] : [];
    
    for(let invoice of payload.invoices){
        newInvoices.push(invoice.invoiceId);
    }
    let uniqueIds = [...new Set(newInvoices)];
    return uniqueIds;
}

const createPropertyInvoicesReducer = (invoices, payload) => {
    let newInvoices = [ ...invoices ];
    
    if (payload.invoices){
        for(let invoice of payload.invoices){
            newInvoices.push(invoice.invoiceId);
        }
    }
    let uniqueIds = [...new Set(newInvoices)];
    return uniqueIds;
}

const addInvoiceReducer = (invoices, payload) => {
    let newInvoices = [ ...invoices ];
    if (payload.addToOrder){
        newInvoices.unshift(payload.invoice.invoiceId)
    }

    return newInvoices;
}

const deleteInvoicesReducer = (invoices, payload) => {
    let remainingInvoices = [ ...invoices ];
    for (const invoiceId of payload.invoiceIds) {
      remainingInvoices = removeArrayElement(remainingInvoices, invoiceId);
    }
    return remainingInvoices;
  };  

const invoicesOrderReducer = (state=[], action) => {
    let invoices = state;
    if (action && action.payload && !action.payload.errors){
        switch(action.type){
            case FETCH_INVOICES:
                return fetchInvoicesReducer(invoices, action.payload);
            case CREATE_PROPERTY_INVOICES:
                return createPropertyInvoicesReducer(invoices, action.payload);
            case ADD_INVOICE:
                return addInvoiceReducer(invoices, action.payload);
            case DELETE_INVOICES:
                return deleteInvoicesReducer(invoices, action.payload);
            case LOG_OUT_USER:
                return [];
            default:
                return invoices;
        }
    }
    return invoices;
}

export default invoicesOrderReducer;